import * as swcHelpers from '@swc/helpers';

function isFormValid(items) {
    return Object.values(items).every((item)=>{
        return Boolean(item === null || item === void 0 ? void 0 : item.isValid);
    });
}
var updateContactDetails = (isCreatingAccount, contactDetails)=>{
    const fullFormData = contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.formData;
    const rest = swcHelpers.objectWithoutProperties(fullFormData, [
        "dateOfBirth"
    ]);
    const formState = isCreatingAccount ? fullFormData : rest;
    return {
        formName: 'contactDetails',
        formState,
        formValid: isFormValid(formState)
    };
};

export { updateContactDetails };
//# sourceMappingURL=update-contact-details.js.map
